<template>
  <div>
   <!--      头部      -->
    <bread></bread>
    <div class="iq-top-navbar">
      <el-page-header @back="$router.go(-1)" content="下级机构工作室">
      </el-page-header>
    </div>
    <!--    内容    -->
    <div class="center-content">
      <div class="iq-card-body">
        <div class="table-top">
          <div class="iq-search-bar">
            <el-button type="primary" size="small" @click="addRole()" plain>新增</el-button>
          </div>
        </div>
        <template v-if="tableData.length > 0">
          <el-table :data="tableData" stripe style="width: 100%;margin-top:20px" :header-cell-style="{ background: '#F5F7FC' }">
            <el-table-column prop="sort" label="排序" align="center"> </el-table-column>
            <el-table-column prop="name" label="名称" align="center"> </el-table-column>
            <el-table-column prop="expertise" label="专科" align="center" > </el-table-column>
            <el-table-column prop="roleKey" label="logo" align="center">
              <template slot-scope="scope">
                <img :src="http + scope.row.logoUrl" alt="" style="width:50px;height:50px" @click="handleImageClick(scope.row)">
              </template>
            </el-table-column>
            <el-table-column prop="enabled" label="是否启用" align="center">
              <template slot-scope="scope">
                <!-- <span>{{scope.row.enabled == '0' ? '禁用' : '启用'}}</span> -->
                <el-switch v-model="scope.row.enabled" @change="handleSet(scope.row)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="recommend" label="总后台是否推荐" align="center">
              <template slot-scope="scope">
                <!-- <span>{{scope.row.enabled == '0' ? '禁用' : '启用'}}</span> -->
                <!-- <el-switch v-model="scope.row.enabled" @change="handleSet(scope.row)"></el-switch> -->
                 <el-switch v-model="scope.row.recommend" disabled :active-value="1" :inactive-value="0"></el-switch>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="300" align="center">
              <template slot-scope="scope">
                <span class="info optionBtn" @click="editTableData(scope.row)">编辑</span>
                <span class="success optionBtn" @click="addSetting(scope.row)">添加成员</span>
                <span class="success optionBtn" @click="seeSetting(scope.row)">查看成员</span>
                <!-- <el-button size="mini" type="primary" @click="addSetting(scope.row)" plain>添加成员</el-button> -->
                <!-- <el-button size="mini" type="warning" @click="catalogueSetting(scope.$index)" plain>目录设置</el-button> -->
                <span class="danger optionBtn" @click="deleteList(scope.row)">删除 </span>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <el-empty v-else :image-size="200"></el-empty>
      </div>
    </div>
    <!--    Dialog 新增    -->
    <el-dialog title="新增工作室" :visible.sync="addDialog">
      <el-form :model="studioForm" :rules="rules" ref="studioForm">
        <el-form-item label="工作组名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="studioForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="专科" :label-width="formLabelWidth" prop="expertise">
          <el-input v-model="studioForm.expertise" autocomplete="off"  maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="启用" :label-width="formLabelWidth">
          <el-switch v-model="studioForm.enabled"></el-switch>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input-number v-model="studioForm.sort" :min="1" ></el-input-number>
        </el-form-item>
        <el-form-item label="logo图片" :label-width="formLabelWidth" prop="logoUrl">
            <el-upload :headers="headers" :action="FileUploadUrl" list-type="picture-card" :file-list="ImageContent" :limit="1" multiple :on-preview="handleImagePreview" :on-remove="handleImageRemove" :on-success="handleImageUpload" accept=".png,.jpg,.jpeg,.gif">
                <i class="el-icon-plus"></i>
            </el-upload>
            <span style="color:red">*推荐上传尺寸750*250</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="addstudioBtn('studioForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--    Dialog 修改    -->
    <el-dialog title="修改工作室" :visible.sync="editDialog">
      <el-form :model="studioForm" :rules="rules" ref="studioForm">
        <el-form-item label="角色名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="studioForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="专科" :label-width="formLabelWidth" prop="expertise">
          <el-input v-model="studioForm.expertise" autocomplete="off"  maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="启用" :label-width="formLabelWidth">
          <el-switch v-model="studioForm.enabled"></el-switch>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input-number v-model="studioForm.sort" :min="1" ></el-input-number>
        </el-form-item>
        <el-form-item label="logo图片" :label-width="formLabelWidth" prop="logoUrl">
            <el-upload :headers="headers" :action="FileUploadUrl" list-type="picture-card" :file-list="ImageContent" :limit="1" multiple :on-preview="handleImagePreview" :on-remove="handleImageRemove" :on-success="handleImageUpload" accept=".png,.jpg,.jpeg,.gif">
                <i class="el-icon-plus"></i>
            </el-upload>
            <span style="color:red">*推荐上传尺寸750*250</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editRoleBtn('studioForm')">确 定</el-button>
      </div>
    </el-dialog>
        <!--    Dialog 修改    -->
    <el-dialog title="选择工作室成员" :visible.sync="setDialog">
          <div class="iq-search-bar" style="display:flex">
            <el-input v-model="setKeyword" placeholder="请输入用户名/账号" style="width:400px"></el-input>
            <el-button type="primary" size="small" @click="searchSet" style="margin-left:10px">搜索</el-button>
          </div>
        <template v-if="setTableData.length > 0">
          <el-table :data="setTableData" stripe style="width: 100%;margin-top:20px;" height="500" ref="multipleTable"  @selection-change="handleChangeData" :header-cell-style="{ background: '#F5F7FC' }">
              <el-table-column
                type="selection"
                width="55"
               >
              </el-table-column>
              <el-table-column prop="userName" label="账号">
                <template slot-scope="scope">
                  <p>{{ scope.row.userName }}</p>
                  <p>{{ scope.row.phone }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="isAuditDiagnose" label="开方权限" align="center">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.isMakeDiagnose" disabled></el-switch>
                </template>
              </el-table-column>
              <el-table-column prop="isAuditDiagnose" label="审方权限" align="center">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.isAuditDiagnose" disabled></el-switch>
                </template>
              </el-table-column>
              <el-table-column prop="enablePhoneConsultation" label="电话权限" align="center">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.enablePhoneConsultation" disabled :active-value="1" :inactive-value="0"> </el-switch>
                </template>
              </el-table-column>
              <el-table-column prop="enableOnlineConsultation" label="问诊权限" align="center">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.enableOnlineConsultation" disabled :active-value="1" :inactive-value="0"></el-switch>
                </template>
              </el-table-column>
              <el-table-column prop="enableAppointment" label="预约挂号权限" align="center">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.enableAppointment" disabled :active-value="1" :inactive-value="0"></el-switch>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="department.name" label="所属部门" align="center" width="150px"> </el-table-column> -->
              <!-- <el-table-column prop="userPost.userPostName" label="职位" align="center" width="150px"> </el-table-column>
              <el-table-column prop="createTime" label="注册时间" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.createTime | timefilters }}</p>
                </template>
            </el-table-column> -->
            <!-- <el-table-column fixed="right" label="操作" width="300" align="center">
              <template slot-scope="scope">
                <span class="success optionBtn" @click="addSetting(scope.row)">添加成员</span>
              </template>
            </el-table-column> -->
          </el-table>
        </template>
      <el-empty v-else :image-size="200"></el-empty>
      <!-- <div slot="footer" class="dialog-footer" style="margin-bottom:20px"> 
        <span style="font-weight: bold;" >是否为传承人：</span><el-switch v-model="userType"></el-switch>
      </div> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="setDialog = false">取 消</el-button>
        <el-button type="primary" @click="setBtn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看工作室成员" :visible.sync="groundDialog">
        <template v-if="groundTableData.length > 0">
          <el-table :data="groundTableData" stripe style="width: 100%;margin-top:20px" :header-cell-style="{ background: '#F5F7FC' }">
              <el-table-column prop="userName" label="账号">
                <template slot-scope="scope">
                  <p>{{ scope.row.userName }}</p>
                  <p>{{ scope.row.phone }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="userType" label="是否为传承人" align="center">
                <template slot-scope="scope" >
                  <el-switch v-model="scope.row.userType" :active-value="1" :inactive-value="0" @change="userTypeSetting(scope.row)"></el-switch>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.createTime | timefilters }}</p>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="300" align="center">
              <template slot-scope="scope">
                <span class="danger optionBtn" @click="deleteSetting(scope.row)">移除</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      <el-empty v-else :image-size="200"></el-empty>
    </el-dialog>
    <el-dialog :visible.sync="Image.dialogVisible">
      <img width="100%" :src="Image.dialogImageUrl" alt="">
    </el-dialog>


  </div>
</template>

<script>
import { studioGroupMain } from "../../../components/studioGroup/studioGroup.js";
import bread from "../../../components/common/breadcrumb";
export default {
  name: "Role",
  components: {
    bread,
  },
  data() {
    var studioGroupItem = new studioGroupMain(this.TokenClient, this.Services.Authorization);
    return {
      Id: this.$route.query.id,
      studioGroupDomain: studioGroupItem,
      FileUploadUrl: this.CommonFilePath,
      tableData: [],
      setTableData:[],
      studioForm: {
        name:'',
        expertise:'',
        enabled:0,
        logoUrl:'',
        sort:1
      },
      rules: {
        name: [{ required: true, message: "请输入工作室名称", trigger: "blur" }],
        expertise: [{ required: true, message: "请输入专科", trigger: "blur" }],
        logoUrl:[{ required: true, message: "请上传logo", trigger: "blur" }]
      },
      formLabelWidth: "120px",
      addDialog: false,
      editDialog: false,
      asstoken:'',
      ImageContent:[],
      Image:{
        dialogImageUrl:'',
        dialogVisible:false
      },
      http:'',
      setDialog:false,
      setKeyword:'',
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      userType:false,
      multipleSelection:[],
      setGroundId:{
        userIds:[],
        userType:0,
        groupId:0
      },
      groundDialog:false,
      groundTableData:[]
    };
  },
  computed: {
      headers() {
      return {
          Authorization: "Bearer" + " " + this.asstoken,
      };
      },
  },
  async mounted() {
    this.asstoken = await this.TokenClient.AccessToken();
    this.http = this.CommonPath
    this.getData();
  },
  methods: {
    seeSetting(item){
      var _this = this
      _this.groundDialog = true
      _this.studioGroupDomain.GetStudioGroupUserData(
        item.id,
          function (data) {
           _this.groundTableData = data.data
          },
          function (err) {
            _this.groundTableData = []
          }
      );
    },
    deleteSetting(item){
      this.$confirm("确定移除该人员?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const _this = this;
          _this.studioGroupDomain.DeleteStudioGroupUserData(
           item.id,
            function () {
              _this.$message({
                type: "success",
                message: "操作成功!",
              });
              /*this.tableData.splice(index, 1);*/
               _this.groundDialog = false
            },
            function (err) {
              var jsonObj = JSON.parse(err.msg);
              if (jsonObj.code == "400") {
                _this.$message({
                  type: "error",
                  message: "该角色已有管理员使用不能删除！",
                });
              }
            }
          );
        })
        .catch(() => {});
    },
    setBtn(){
      var _this = this
      if (_this.setGroundId.userIds.length == 0) {
        _this.$message({
          type: "error",
          message: '请选择工作室成员',
        });
        return
      }
      _this.setGroundId.userType = 0
      _this.studioGroupDomain.SetStudioGroupUser(
        _this.setGroundId,
          function (data) {
            _this.$message({
              type: "success",
              message: "设置成功!",
            });
            _this.setDialog = false
          },
          function (err) {
            _this.setTableData = []
          }
      );
    },
    handleChangeData(val) {
      console.log(val)
      this.multipleSelection = val;
      let parmas = []
      this.multipleSelection.map((res)=>{
        parmas.push(res.id)
      })
      this.setGroundId.userIds = parmas
    },
    searchSet(){
      var _this = this
      let setKeywordData = _this.setKeyword == '' ? '%20' : _this.setKeyword
      _this.studioGroupDomain.GetDistributorPages(
        _this.Id,setKeywordData,
          function (data) {
            _this.setTableData = data.data.results
          },
          function (err) {
            _this.setTableData = []
          }
      );

    },
    addSetting(item){
      this.setGroundId.groupId = item.id
      this.setKeyword = ''
      this.setTableData = []
      this.userType = 0
      this.setGroundId.userIds = []
      this.searchSet()
      this.setDialog = true
    },
    handleImageClick(e){
      console.log(e)
      this.Image.dialogImageUrl = this.http + e.logoUrl;
      this.Image.dialogVisible = true;
    },
    handleImageUpload(response, file, fileList) {
        var _this = this;
        _this.ImageContent =[]
        response.forEach(function (file) {
            var imgarr = {
            filePath: file.completeFilePath,
            fileName: file.fileName,
            type: 0,
            url:_this.http + file.completeFilePath
            };
            _this.ImageContent.push(imgarr);
        });
        _this.studioForm.logoUrl = _this.ImageContent[0].filePath.toString()
    },
    handleImagePreview(file) {
        this.Image.dialogImageUrl = file.url;
        this.Image.dialogVisible = true;
    },
    handleImageRemove(file, fileList) {
        var _this = this;
        const filePath = file.response[0].completeFilePath;
        //2.从pics数组中找到图片对应的索引值
        //形参‘x’，是数组pic里的每一项
        const i = _this.ImageContent.findIndex((x) => x.completeFilePath == filePath);
        //调用数组的splice方法，把图片的信息对象从pics数组中移除
        _this.ImageContent.splice(i, 1);
    },
    getData() {
      var _this = this
      _this.studioGroupDomain.GetOrgStudioGroupList(
        _this.Id,
        function (data) {
          _this.tableData = data.data
          _this.tableData.map((res) => {
            res.enabled = res.enabled == 0 ? false : true;
          })
        },
        function (err) {
          _this.tableData = []
        }
      );
    },
    //新增
    addRole() {
      this.studioForm = {
        name:'',
        expertise:'',
        enabled:0,
        logoUrl:'',
        sort:1
      },
      this.ImageContent = []
      //   设置点击按钮之后进行显示对话框
      this.addDialog = true;
    },
    editRoleBtn(studioForm){
      const _this = this;
      _this.$refs[studioForm].validate((valid) => {
        if (valid) {
          _this.studioForm.enabled = _this.studioForm.enabled ? 1 : 0
          _this.studioGroupDomain.AddSubmitStudioGroup(
            _this.studioForm,
            function (data) {
              _this.getData();
              _this.editDialog = false;
              _this.$message({
                type: "success",
                message: "添加成功!",
              });
            },
            function (err) {
              var jsonObj = JSON.parse(err.msg);
              if (jsonObj.code == "400") {
                that.$message({
                  type: "error",
                  message: jsonObj.msg,
                });
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addstudioBtn(studioForm) {
      const _this = this;
      _this.$refs[studioForm].validate((valid) => {
        if (valid) {
          _this.studioForm.enabled = _this.studioForm.enabled ? 1 : 0
          _this.studioGroupDomain.AddSubmitStudioChildGroup(
            _this.Id,
            _this.studioForm,
            function (data) {
              _this.getData();
              _this.addDialog = false;
              _this.$message({
                type: "success",
                message: "添加成功!",
              });
            },
            function (err) {
              var jsonObj = JSON.parse(err.msg);
              if (jsonObj.code == "400") {
                that.$message({
                  type: "error",
                  message: jsonObj.msg,
                });
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //编辑
    editTableData(item) {
      this.studioForm.id = item.id;
      this.studioForm.name = item.name;
      this.studioForm.expertise = item.expertise;
      this.studioForm.logoUrl = item.logoUrl;
      this.studioForm.enabled = item.enabled == 0 ? false : true;
      this.studioForm.sort = item.sort
      this.ImageContent = []
      var imgarr = {
        filePath: item.logoUrl,
        fileName: '',
        type: 0,
        url:this.http + item.logoUrl
      };
      this.ImageContent.push(imgarr);
      console.log(this.ImageContent)
      this.editDialog = true;
    },
    handleSet(item){
      console.log(item)
      const _this = this;
      _this.studioGroupDomain.SetStudioGroupEnabledData(
        item.id,
        function () {
          _this.$message({
            type: "success",
            message: "操作成功!",
          });
          /*this.tableData.splice(index, 1);*/
          _this.getData();
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: "操作失败",
            });
          }
        }
      );
    },
    userTypeSetting(item){
      const _this = this;
      _this.studioGroupDomain.SetStudioUserInheritData(
        item.id,
        function () {
          _this.$message({
            type: "success",
            message: "操作成功!",
          });
          /*this.tableData.splice(index, 1);*/
          // _this.getData();
          _this.studioGroupDomain.GetStudioGroupUserData(
            item.studioGroupId,
            function (data) {
            _this.groundTableData = data.data
            },
            function (err) {
              _this.groundTableData = []
            }
          );
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: "操作失败",
            });
          }
        }
      );
    },
    //删除
    deleteList(item) {
      this.$confirm("确定删除该工作室?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const _this = this;
          _this.studioGroupDomain.DeleteStudioGroupData(
           item.id,
            function () {
              _this.$message({
                type: "success",
                message: "操作成功!",
              });
              /*this.tableData.splice(index, 1);*/
              _this.getData();
            },
            function (err) {
              var jsonObj = JSON.parse(err.msg);
              if (jsonObj.code == "400") {
                _this.$message({
                  type: "error",
                  message: "该角色已有管理员使用不能删除！",
                });
              }
            }
          );
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
/*content*/

.iq-search-bar {
  display: inline-block;
  margin-right: 20px;
}

.iq-search-bar .searchbox {
  width: 480px;
  position: relative;
}

.iq-search-bar .searchbox .search-link {
  position: absolute;
  right: 15px;
  top: 2px;
  font-size: 16px;
}

.iq-search-bar .search-input {
  width: 100%;
  padding: 5px 40px 5px 15px;
  border-radius: 10px;
  border: none;
  background: #ceebee;
  line-height: 1.8;
}
</style>
<style>
.el-scrollbar__wrap {
  overflow: auto;
}
</style>
